export default {
  meta: {
    title: "PixelHaha {'|'} Free Stock Images for Download",
    description:
      "Explore a wide variety of stunning images. From landscapes to abstract art, all images are free and perfect for enriching your design ideas and social media graphics.",
    keywords: "free, stock, gallery, text-to-image, AI generate",
    searchTitle:
      "PixelHaha {'|'} {number}+ Best {keyword} · 100% Free Download",
    searchDescription:
      "Download the perfect {keyword} pictures. Find over {number}+ of the best free {keyword} images. Free for commercial use No attribution required Copyright-free.",
    404: "Error 404 - PixelHaha",
  },
};
